
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 23 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.6 1.9c.6-1.8 3.2-1.8 3.8 0l1.1 3.5c.3.8 1 1.4 1.9 1.4h3.7c1.9 0 2.7 2.5 1.2 3.6l-3 2.1c-.7.5-1 1.4-.7 2.2l1.1 3.5c.6 1.8-1.5 3.4-3.1 2.2l-3-2.1c-.7-.5-1.7-.5-2.4 0l-3 2.1c-1.6 1.1-3.7-.4-3.1-2.2l1.1-3.5c.3-.8 0-1.7-.7-2.2l-3-2.1C.2 9.2 1 6.7 2.9 6.7h3.7c.9 0 1.6-.6 1.9-1.4z","fill":"#F9DFB3"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M11 .5c-.6.2-1.2.6-1.4 1.3L8.5 5.3c-.3.8-1 1.4-1.9 1.4H2.9C1 6.7.2 9.2 1.7 10.3l3 2.1c.7.5 1 1.4.7 2.2l-1.1 3.5c-.6 1.8 1.5 3.4 3.1 2.2l3-2.1c.2-.2.4-.3.7-.3V.5z","fill":"#f9a91e","fill-rule":"evenodd"}})])
          )
        }
      }
    